import React from 'react';
import useWsEvents from '../../custom_hooks/useWsEvents';
import { SnackbarKey, useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import CancelIcon from '@material-ui/icons/Cancel';
import { useNavigate } from 'react-router';

const PlayerDataStatusWidget = () => {
  const snackbarRef = React.useRef<null | SnackbarKey>(null);
  const {enqueueSnackbar, closeSnackbar} = useSnackbar();
  const {t} = useTranslation();
  const navigate = useNavigate();

  const handleClose = () => {
    if (snackbarRef.current) {
      closeSnackbar(snackbarRef.current);
    }
  }

  useWsEvents('ws.viewerDataStatus', (eventData) => {
    if (eventData.team_id && eventData.team_session_id && eventData.env) {
      snackbarRef.current = enqueueSnackbar(
        <div className="player-message-data__ready">
          <h3>{t('player.playerIsReady', 'Positional data is ready')}</h3>
          <p>{t('player.playerIsReadyMsg', 'You can now start playing the viewer')}</p>
          <br />
          <button
            className="player-message-data_button"
            onClick={() => {
              handleClose();
              navigate(`/sessions/${eventData.team_session_id}?tab=webPlayer&teamId=${eventData.team_id}`);
            }}
          >
            <strong>
              {t('player.message-view-link', 'go to session')}
            </strong>
          </button>
          <button className="snackbar-close" onClick={handleClose}><CancelIcon fontSize="small" /></button>
        </div>,
        {
          variant: 'info',
          persist: true,
          title: t('player.dataIsReady', 'Data is ready'),
        }
      );
    }
  });

  return null;
}

export default PlayerDataStatusWidget;
